import React from 'react';
import { ProgressBar } from 'react-bootstrap';

const LoadingBar = ({ show }) => {
  return (
    <div className={`loading-bar ${show ? '' : 'hidden'}`}>
      <ProgressBar animated now={100} style={{ width: '100%' }} />
    </div>
  );
};

export default LoadingBar;